var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "tab-detail" }, [
    _c("div", { staticClass: "header" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("googlePlay.channelDetails"))),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "form-content" },
      [
        _c(
          "a-form-item",
          { attrs: { label: _vm.$t("googlePlay.channelName") } },
          [
            _c("a-input", {
              model: {
                value: _vm.localChannel.name,
                callback: function ($$v) {
                  _vm.$set(_vm.localChannel, "name", $$v)
                },
                expression: "localChannel.name",
              },
            }),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "a-form-item",
          { attrs: { label: _vm.$t("googlePlay.status") } },
          [
            _c("a-switch", {
              model: {
                value: _vm.localChannel.enabled,
                callback: function ($$v) {
                  _vm.$set(_vm.localChannel, "enabled", $$v)
                },
                expression: "localChannel.enabled",
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "status-text" }, [
              _vm._v(
                _vm._s(
                  _vm.localChannel.enabled
                    ? _vm.$t("googlePlay.enabled")
                    : _vm.$t("googlePlay.disabled")
                )
              ),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-actions" },
          [
            _c(
              "a-button",
              {
                attrs: { type: "primary", loading: _vm.saving },
                on: { click: _vm.save },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.$t("googlePlay.save")) +
                    "\n            "
                ),
              ]
            ),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }